const papersDataCambridgeIgcse = {
  mathematics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s25_ms_43.pdf',
        },
      ],
    },
    {
      year: '2025 (Specimen)',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/663662-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663670-2025-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/663664-2025-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663672-2025-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/663666-2025-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663674-2025-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/663668-2025-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663676-2025-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_42.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Maths/GCSE/Past-Papers/CIE/Paper-2/International/QP/June%202023%20(v3)%20QP.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_ms_23.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_ms_33.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0580_s23_ms_43.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/415732-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415728-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/415739-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/images/415736-2020-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/images/415744-2020-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415742-2020-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/images/415748-2020-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415746-2020-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_41.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_ms_43.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_ms_53.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_qp_63.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s25_ms_63.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_42.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_52.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_62.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_62.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_qp_13.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Biology/GCSE/Past-Papers/CIE/Paper-1/International/MS/June%202023%20(v1)%20MS.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_qp_23.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Biology/GCSE/Past-Papers/CIE/Paper-2/International/MS/June%202023%20(v2)%20MS.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_ms_33.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Biology/GCSE/Past-Papers/CIE/Paper-4/International/QP/June%202023%20(v3)%20QP.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_ms_43.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_ms_53.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pmt.physicsandmathstutor.com/download/Biology/GCSE/Past-Papers/CIE/Paper-6/International/QP/June%202023%20(v2)%20QP.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0610_s23_ms_63.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/caie/IGCSE/Biology-0970-UK/2022-May-June/0970_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/caie/IGCSE/Biology-0970-UK/2022-May-June/0970_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/caie/IGCSE/Biology-0970-UK/2022-May-June/0970_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/03/0970_s18_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_61.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_ms_43.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_ms_53.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_qp_63.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0620_s25_ms_63.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/520441-june-2023-question-paper-11.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Chemistry/GCSE/Past-Papers/CIE/Paper-1/International/MS/June%202023%20(v2)%20MS.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/520512-june-2023-question-paper-21.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Chemistry/GCSE/Past-Papers/CIE/Paper-2/International/MS/June%202023%20(v2)%20MS.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Chemistry/GCSE/Past-Papers/CIE/Paper-3/International/QP/June%202023%20(v2)%20QP.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Chemistry/GCSE/Past-Papers/CIE/Paper-3/International/MS/June%202023%20(v2)%20MS.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Chemistry/GCSE/Past-Papers/CIE/Paper-4/International/QP/June%202023%20(v1)%20QP.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671413-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cambridgeinternational.org/Images/671420-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671414-june-2023-mark-scheme-paper-51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cambridgeinternational.org/Images/671421-june-2023-question-paper-61.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671415-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_61.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_ms_43.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_ms_53.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_qp_63.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0625_s25_ms_63.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Physics/GCSE/Past-Papers/CIE/Paper-1/International/QP/June%202023%20(v1)%20QP.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570004-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Physics/GCSE/Past-Papers/CIE/Paper-2/International/QP/June%202023%20(v3)%20QP.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Physics/GCSE/Past-Papers/CIE/Paper-2/International/MS/June%202023%20(v2)%20MS.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/570012-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570006-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Physics/GCSE/Past-Papers/CIE/Paper-4/International/QP/June%202023%20(v1)%20QP.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671373-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cambridgeinternational.org/Images/671386-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671374-june-2023-mark-scheme-paper-51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cambridgeinternational.org/Images/671387-june-2023-question-paper-61.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671375-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_42.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_52.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_62.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_62.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pmt.physicsandmathstutor.com/download/Physics/GCSE/Past-Papers/CIE/Paper-1/International/QP/June%202018%20QP.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_61.pdf',
        },
      ],
    },
  ],
  coordinatedscience: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_qp_13.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_qp_23.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_qp_33.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_qp_43.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_ms_43.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_qp_53.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_ms_53.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_qp_63.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/IGCSE/Sciences-Co-ordinated-Double-0654/2025-May-June/0654_s25_ms_63.pdf',
        },
      ],
    },
    {
      year: '2025 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/671101-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671110-2025-specimen-mark-scheme-paper-1.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/671102-2025-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671111-2025-specimen-mark-scheme-paper-2-.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/671103-2025-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671112-2025-specimen-mark-scheme-paper-3-.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/671242-2025-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671244-2025-specimen-paper-4-mark-scheme.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/671401-2025-specimen-paper-5.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671406-2025-specimen-mark-scheme-5.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cambridgeinternational.org/Images/671402-2025-specimen-paper-6.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671407-2025-specimen-mark-scheme-6.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_ms_43.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_ms_53.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_qp_63.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0654_s23_ms_63.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_1_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_1_1_ms.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_2_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_2_1_ms.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_3_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_3_1_ms.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_4_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_4_1_ms.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_5_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_5_1_ms.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_6_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_6_1_ms.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s25_ms_23.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0455_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_ms_22.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_ms_22.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414644-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414652-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414646-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414654-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_ms_21.pdf',
        },
      ],
    },
  ],
  businessstudies: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s25_ms_23.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0450_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414604-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414610-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414605-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414611-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_ms_21.pdf',
        },
      ],
    },
  ],
  englishlanguage: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s25_ms_23.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pmt.physicsandmathstutor.com/download/English-Language/GCSE/Past-Papers/CIE/Paper-1/QP/June%202023%20(v3)%20QP.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0500_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414814-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414873-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414816-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414811-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_ms_21.pdf',
        },
      ],
    },
  ],
  englishliterature: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s25_ms_43.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pmt.physicsandmathstutor.com/download/English-Literature/GCSE/Past-Papers/CIE/Paper-1/QP/June%202023%20(v1)%20QP.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0475_s23_ms_43.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414753-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414779-2020-specimen-mark-scheme-1.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414755-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414780-2020-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/414758-2020-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414783-2020-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/414759-2020-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414784-2020-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_41.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_41.pdf',
        },
      ],
    },
  ],
  additionalmathematics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s25_ms_23.pdf',
        },
      ],
    },
    {
      year: '2025 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/664576-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/664580-specimen-paper-1-markscheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/664577-2025-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/664581-2025-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0606_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/images/415791-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/664580-specimen-paper-1-markscheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/415797-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415794-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_ms_21.pdf',
        },
      ],
    },
  ],
  computerscience: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s25_ms_23.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s23_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0478_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_ms_21.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_ms_21.pdf',
        },
      ],
    },
  ],
  environmentalmanagement: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01 (Theory)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02 (Management in context)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_ms_21.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01 (Theory)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02 (Management in context)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01 (Theory)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s23_ms_13.pdf',
        },
        {
          label: 'Paper 02 (Management in context)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01 (Theory)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02 (Management in context)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_ms_21.pdf',
        },
      ],
    },
  ],
  french: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_ms_23.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_tn_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_rp_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s23_ms_43.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_ms_41.pdf',
        },
      ],
    },
  ],
  german: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_ms_23.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s23_ms_43.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_ms_41.pdf',
        },
      ],
    },
  ],
  spanish: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_ms_23.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s23_ms_43.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_ms_41.pdf',
        },
      ],
    },
  ],
  statistics: [
    {
      year: '2027 (Specimen)',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/718826-2027-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/718830-2027-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/718827-2027-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/718831-2027-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
  ],
  history: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s25_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s25_ms_23.pdf',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s25_ms_43.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s24_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s24_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s24_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s24_ms_23.pdf',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s24_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s24_ms_43.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s23_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s23_ms_23.pdf',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s23_ms_43.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s22_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s22_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s22_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s22_ms_23.pdf',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s22_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0470_s22_ms_43.pdf',
        },
      ],
    },
  ],
  geography: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_ms_13.pdf',
        },
        {
          label: 'Insert 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_in_13.pdf',
          marking: '',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_ms_23.pdf',
        },
        {
          label: 'Insert 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_in_23.pdf',
          marking: '',
        },
        {
          label: 'Insert 2.1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_i2_23.pdf',
          marking: '',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_ms_43.pdf',
        },
        {
          label: 'Insert 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s25_in_43.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_ms_13.pdf',
        },
        {
          label: 'Insert 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_in_13.pdf',
          marking: '',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_ms_23.pdf',
        },
        {
          label: 'Insert 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_in_23.pdf',
          marking: '',
        },
        {
          label: 'Insert 2.1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_i2_23.pdf',
          marking: '',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_ms_43.pdf',
        },
        {
          label: 'Insert 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s24_in_43.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_ms_13.pdf',
        },
        {
          label: 'Insert 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_in_13.pdf',
          marking: '',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_ms_23.pdf',
        },
        {
          label: 'Insert 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_in_23.pdf',
          marking: '',
        },
        {
          label: 'Insert 2.1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_i2_23.pdf',
          marking: '',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_ms_43.pdf',
        },
        {
          label: 'Insert 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s23_in_43.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_ms_13.pdf',
        },
        {
          label: 'Insert 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_in_13.pdf',
          marking: '',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_ms_23.pdf',
        },
        {
          label: 'Insert 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_in_23.pdf',
          marking: '',
        },
        {
          label: 'Insert 2.1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_i2_23.pdf',
          marking: '',
        },
        {
          label: 'Paper 04 (Alternative to coursework)',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_ms_43.pdf',
        },
        {
          label: 'Insert 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0460_s22_in_43.pdf',
          marking: '',
        },
      ],
    },
  ],
  accounting: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s25_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s25_ms_23.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s24_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s24_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s24_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s24_ms_23.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s23_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s23_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s23_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s23_ms_23.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s22_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s22_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s22_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s22_ms_23.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s21_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s21_ms_13.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s21_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0452_s21_ms_23.pdf',
        },
      ],
    },
  ],
};

export default papersDataCambridgeIgcse;
